/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import { LocationInput } from 'module-tsl-ui-jobs-location-input';
import { getFromContext } from '../../../AlertFiltersContext';

export const FilterInputLocation = () => {
  const { state, dispatch } = getFromContext();
  const [locationFacet] = state.facets.filter(
    ({ queryStringId }) => queryStringId.indexOf('location') !== -1 || queryStringId.indexOf('point') !== -1,
  );

  const [location, setLocation] = useState(
    locationFacet && locationFacet.name ? decodeURIComponent(locationFacet.name) : '',
  );

  const inputRef = React.useRef();

  const onRemove = () => {
    if (inputRef.current.value !== '') {
      inputRef.current.resetLocation('');
      setLocation('');

      const [distanceFacet] = state.facets.filter(({ queryStringId }) => queryStringId.indexOf('maxdistance') !== -1);

      if (distanceFacet) {
        dispatch({
          type: 'remove',
          facet: distanceFacet,
        });
      }

      dispatch({
        type: 'enableDistance',
        enable: false,
      });
    }
  };

  useEffect(() => {
    if (locationFacet) {
      return setLocation(decodeURIComponent(locationFacet.name));
    }

    onRemove();
  }, [state.facets]);

  const onLocationChange = (newValue, item) => {
    if (item && item.value !== '') {

    // {
    //    coordinates: "53.382507649766225,-1.4685363853125781"
    //    location: "United Kingdom:England:Yorkshire and the Humber:Sheffield"
    //    value: "Sheffield"
    // }

      const value = item.location || item.coordinates;
      setLocation(value);

      const isPoint = item.coordinates;

      dispatch({
        type: 'enableDistance',
        enable: isPoint,
      });

      const params = [`displayLocation=${encodeURIComponent(item.value)}`];

      if (item.location) {
        params.push(`locations=${encodeURIComponent(item.location)}`);
      }

      if (item.coordinates) {
        params.push(`point=${encodeURIComponent(item.coordinates)}`);
      }

      const queryStringId = params.join('&');

      const facet = {
        name: item.value,
        queryStringId,
        queryAs: item.value,
      };

      dispatch({
        type: locationFacet ? 'update' : 'add',
        facet,
        key: locationFacet && locationFacet.queryStringId.split('=')[0],
      });
    }

    if (newValue === '' && Boolean(locationFacet)) {
      dispatch({
        type: 'remove',
        facet: locationFacet,
      });
    }
  };

  return (
    <LocationInput
      self={{
        group: 'location',
        displayLocationPicker: true,
        siteCountry: state.i18n && state.i18n.siteCountry,
      }}
      label={{ text: 'Location' }}
      input={{
        mapsApiKey: state.mapsApiKey,
        onLocationChange,
        placeholder: 'Location or postcode',
        defaultValue: location,
      }}
      ref={inputRef}
    />
  );
};
